import { useContext, useState } from "react";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import { Button, Tooltip } from "@mui/material";
import clsx from "clsx";
// import { useRouter } from "next/router";
import { Icon } from "../Icon";
import { TabsMenuContext } from "contexts/TabsMenuContext";
import { useAuth } from "contexts/auth";
import RegionSelector from "components/Header/RegionSelector";
import { useTranslation } from "react-i18next";

interface HeaderTypes {
  className?: string;
}

export default function Header(props: HeaderTypes) {
  const { className } = props;
  const { t } = useTranslation();
  const contextData = useContext(TabsMenuContext);
  //   const router = useRouter();
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    useState<null | HTMLElement>(null);
  const { logOut, user } = useAuth();

  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    handleMobileMenuClose();
  };

  const handleClickUserProfile = () => {
    // if (contextData.isTabInActiveTabItems(outsideMenuRoutes.userProfile)) {
    //   contextData.activateTab(outsideMenuRoutes.userProfile);
    // } else {
    //   contextData.addNewTabOutsideOfMenu(
    //     "پروفایل کاربری",
    //     "/dashboard/userProfile",
    //     {}
    //   );
    // }
    //
    // router.push({
    //   pathname: "/dashboard/userProfile",
    // });
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleClickUserProfile}>
        <Button
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <Icon icon="MdOutlineAccountCircle" fontSize="1.5rem" />
        </Button>
        <p>پروفایل</p>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      <Toolbar
        className={clsx(
          className,
          "bg-neutral-20 pt-[4px] pb-[3px] border-b-[1px] border-b-gray-30 h-14 z-20 shadow-sm"
        )}
        style={{ minHeight: "10px" }}
      >
        <div className="flex-grow flex items-center justify-start">
          <RegionSelector />
        </div>
        <div className="flex xs:hidden md:flex items-center">
          <Button
            // className="h-8 text-sm text-mofidGray-110 hover:text-mofidBlue-90 hover:bg-mofidNeutral-20 rounded-lg"

            className="flex justify-between items-center hover:text-primary-90 hover:bg-neutral-20 rounded-lg mr-6"
            size="large"
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            onClick={handleClickUserProfile}
            color="primary"
          >
            <Icon
              fontSize="22"
              icon="MdAccountCircle"
              className={"text-gray-70"}
            />

            <span className="mt-[1px] mr-1 text-gray-110">{`${user?.firstName} ${user?.lastName}`}</span>
          </Button>

          <Tooltip title={"خروج"} placement="bottom">
            <Button
              className="group h-8 text-gray-110 bg-neutral-45 hover:text-gray-white hover:bg-gray-60 rounded-lg mr-4"
              size="large"
              color="primary"
              onClick={() => {
                // handleMenuClose();
                logOut?.();
              }}
            >
              <Icon
                icon="MdOutlineLogout"
                className="rotate-180 group-hover:text-gray-white"
                fontSize="18"
              />
              <span className="mr-1 mt-[1px]">{t("logOut")}</span>
            </Button>
          </Tooltip>
        </div>
        <div className="xs:flex sm:hidden">
          <Button
            size="large"
            aria-label="show more"
            aria-controls={mobileMenuId}
            aria-haspopup="true"
            onClick={handleMobileMenuOpen}
            color="primary"
          >
            <Icon icon="MdMoreVert" fontSize="1.5rem" />
          </Button>
        </div>
      </Toolbar>
      {renderMobileMenu}
    </>
  );
}
